import { motion } from "framer-motion";
import { MessageSquare, Lock, Calendar, Wand2, ShieldCheck } from "lucide-react";

const ITEMS = [
  { Icon: MessageSquare, title: "Professional Communication", body: "Every email, call, and follow-up handled with the polish your clients expect from a senior office." },
  { Icon: Lock, title: "Confidential Service", body: "NDAs available on request. We treat sensitive business information with strict discretion." },
  { Icon: Calendar, title: "Flexible Support", body: "Engage by the hour, by the week, or full-time. No long-term lock-ins, no surprise fees." },
  { Icon: Wand2, title: "Customized Solutions", body: "Plans built around your workflow, software, and pace — not generic admin packages." },
  { Icon: ShieldCheck, title: "Reliable Administrative Assistance", body: "Consistent, organized, and on-time support — week after week, month after month." },
];

export default function TrustReasons() {
  return (
    <section className="relative py-28 lg:py-36 bg-secondary/40 overflow-hidden" data-testid="trust-reasons-section">
      <div className="container-apex">
        <div className="max-w-3xl">
          <div className="overline">Why Businesses Choose Us</div>
          <h2 className="heading-display text-4xl sm:text-5xl lg:text-6xl mt-5 text-balance">
            A new standard for outsourced <span className="text-[#16A34A]">office support</span> in Canada.
          </h2>
          <p className="mt-6 text-muted-foreground text-lg">
            We&apos;re a new business with high standards. Instead of inventing reviews, here&apos;s exactly what every client can expect from day one.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-5 gap-5">
          {ITEMS.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.07 }}
              className="card-apex p-6 flex flex-col"
              data-testid={`trust-${i}`}
            >
              <div className="w-11 h-11 rounded-xl bg-[#16A34A]/10 text-[#16A34A] flex items-center justify-center">
                <it.Icon size={18} />
              </div>
              <h3 className="mt-5 font-display font-bold text-base lg:text-lg leading-tight">{it.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{it.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
